import { TOGGLE_DEFERRED_SUBMISSIONS_BEGIN } from '../actions/settings';
import { SETTINGS_TAB_CHANGE } from "../actions/settings";
import LadderLocalStorage from "../../utilities/LadderLocalStorage.jsx";
import { SET_PLAYER } from "../actions/dashboard.js";
import { TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_BEGIN } from "../actions/settings";
import { TOGGLE_CALENDAR_ENABLED_BEGIN, TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_BEGIN } from "../actions/settings.js";
import { FREE_FORM_BUDGETING_ENABLED_BEGIN } from "../actions/settings";
import {
	API_TOKEN_CREATE_BEGIN,
	API_TOKEN_CREATE_SUCCESS,
	API_TOKEN_REVOKE_BEGIN,
	API_TOKEN_REVOKE_SUCCESS,
	API_TOKENS_ERROR_DISMISSED,
	API_TOKENS_FAIL,
	API_TOKENS_LOAD_BEGIN,
	API_TOKENS_LOAD_SUCCESS,
} from "../actions/settings.js";


const initialState = {
	calendarFeatureActive: true,
	separateBudgetTabsFeatureActive: false,
	showTotalsWithinEachCategoryFeatureActive: false,
	freeFormBudgetingFeatureActive: false,
	deferredSubmissionsActive: true,
	activeBudget: null,
	/** Metadata only: the plaintext of a new token never reaches the store. */
	apiTokens: null,
	loadingApiTokens: false,
	creatingApiToken: false,
	revokingApiTokenId: null,
	apiTokensError: null,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case SET_PLAYER: {
			const player = action.payload;
			if(!player.features) {
				player.features = {};
			}
			const thingsToSet = {
				calendarFeatureActive: player ? !!player.features.CALENDAR : false,
				separateBudgetTabsFeatureActive: player ? !!player.features.SEPARATE_BUDGET_CATEGORY_TABS : false,
				showTotalsWithinEachCategoryFeatureActive: player ? !!player.features.SHOW_TOTALS_WITHIN_EACH_CATEGORY : false,
				freeFormBudgetingFeatureActive: player ? !!player.features.FREE_FORM_BUDGETING : false,
			};

			if(player.active_budget){
				thingsToSet.activeBudget = player.active_budget;
			}

			return {
				...state,
				...thingsToSet
			};
		}
		case TOGGLE_CALENDAR_ENABLED_BEGIN: {

			return {
				...state,
				calendarFeatureActive: action.payload,
			};
		}
		case TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_BEGIN: {
			return {
				...state,
				separateBudgetTabsFeatureActive: action.payload,
			};
		}
		case TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_BEGIN: {
			return {
				...state,
				showTotalsWithinEachCategoryFeatureActive: action.payload,
			};
		}
		case FREE_FORM_BUDGETING_ENABLED_BEGIN: {
			return {
				...state,
				freeFormBudgetingFeatureActive: action.payload,
			};
		}
		case TOGGLE_DEFERRED_SUBMISSIONS_BEGIN: {
			return {
				...state,
				deferredSubmissionsActive: action.payload,
			};
		}
		case API_TOKENS_LOAD_BEGIN: {
			return { ...state, loadingApiTokens: true, apiTokensError: null };
		}
		case API_TOKENS_LOAD_SUCCESS: {
			return { ...state, loadingApiTokens: false, apiTokens: action.payload || [] };
		}
		case API_TOKEN_CREATE_BEGIN: {
			return { ...state, creatingApiToken: true, apiTokensError: null };
		}
		case API_TOKEN_CREATE_SUCCESS: {
			return { ...state, creatingApiToken: false, apiTokens: action.payload.api_tokens || [] };
		}
		case API_TOKEN_REVOKE_BEGIN: {
			return { ...state, revokingApiTokenId: action.payload, apiTokensError: null };
		}
		case API_TOKEN_REVOKE_SUCCESS: {
			return { ...state, revokingApiTokenId: null, apiTokens: action.payload || [] };
		}
		case API_TOKENS_FAIL: {
			return {
				...state,
				loadingApiTokens: false,
				creatingApiToken: false,
				revokingApiTokenId: null,
				apiTokensError: action.payload,
			};
		}
		case API_TOKENS_ERROR_DISMISSED: {
			return { ...state, apiTokensError: null };
		}
		default:
			return state;
	}
}